import { createListenerMiddleware } from "@reduxjs/toolkit";
import { setLogout } from "features/authSlice";
import { setNativeAppBannerDismissed } from "features/nativeAppPromoSlice";
import { setIsLanguageToggleLocked } from "features/preferredLanguageSlice";
import { afterLogoutApi } from "pages/login/afterLogoutService";
import { clearLoanOfficerDetail } from "services/common/loanOfficerSlice";
import { NATIVE_APP_AD_ELIGIBILITY_KEY, NATIVE_APP_BANNER_DISMISS_KEY } from "utilities/Constant";
import { clearPreferredLanguageStorageOnLogout } from "utilities/getPreferredLanguage";

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: setLogout,
  effect: async (_, listenerApi) => {
    listenerApi.dispatch(clearLoanOfficerDetail());
    listenerApi.dispatch(setIsLanguageToggleLocked(false));
    listenerApi.dispatch(setNativeAppBannerDismissed(false));
    
    // Clear native app promo session storage on logout
    sessionStorage.removeItem(NATIVE_APP_BANNER_DISMISS_KEY);
    sessionStorage.removeItem(NATIVE_APP_AD_ELIGIBILITY_KEY);
    clearPreferredLanguageStorageOnLogout();
    
    try {
      await listenerApi.dispatch(afterLogoutApi.endpoints.postAfterLogout.initiate());
    } catch (err) {
      console.error("Failed to call after-logout endpoint", err);
    }
  },
});
